import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { A11y, Navigation, Pagination, Scrollbar } from "swiper/modules";
import { useSwiper } from "swiper/react";
import { PlusIcon } from "../../configs/svg";
import {
  useAddpatientMutation,
  useUpdatepatientMutation,
} from "../../Redux/services/ClientAPis/patientApi";
import { useUploadAttachmentMutation } from "../../Redux/services/userAuthApi";
import { validation, validationText } from "../../utils/constants";
import { errorToast, formatDate, success } from "../../utils/helpers";
import { SwipperComponent } from "../CustomComponent/Swiper";
import ThemeInput from "../ThemeComponent/ThemeInput";
import ThemeSpinner from "../ThemeComponent/ThemeSpinner";
import { SimpleBasic } from "../ThemeComponent/ThemeText";
import ThemeTextArea from "../ThemeComponent/ThemeTextArea";

const AddPatient = ({ setIsOpen, modalData, refetch }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageFiles, setImageFiles] = useState(["/images/pdf_image.png"]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const dispatch = useDispatch();
  const swiper = useSwiper();
  const {
    handleSubmit,
    control,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const handleImageChange = (event) => {
    setSelectedImage(event.target.files[0]);
  };

  const [addpatient, { isLoading: addLoading }] = useAddpatientMutation();
  const [updatepatient, { isLoading }] = useUpdatepatientMutation();
  const [uploadAttachment, { isLoading: attchadding }] =
    useUploadAttachmentMutation();

  const options = [
    { label: "Doctor", value: "1" },
    { label: "Helper", value: "2" },
    { label: "Nurse", value: "3" },
  ];

  const uploadAttachemnt = async (image) => {
    let formData = new FormData();
    formData.append("file", image);
    formData.append("path", "user");
    try {
      const response = await uploadAttachment(formData);
      const obj = {
        media_url: response?.data?.data[0],
        media_type: response?.data?.data[0].split(".").pop(),
      };
      let temp = [];
      temp.push(obj);
      setUploadedFiles(temp);
      success(response?.data?.message);
    } catch (error) {
      errorToast(error.message);
    }
  };

  const handleAddfilesAndSelect = (e) => {
    const files = Array.from(e.target.files);
    uploadAttachemnt(e.target.files[0]);
    const doc = URL.createObjectURL(e.target.files[0]);
    setTimeout(() => setImageFiles([...imageFiles, doc]), 1000);
    const file = document.getElementById("addimges");
  };

  const onSubmit = async (data) => {
    const payload = { ...data, id: modalData?.id, documents: uploadedFiles };
    try {
      let response;
      if (modalData) {
        response = await updatepatient(payload);
      } else {
        response = await addpatient({ ...data, documents: uploadedFiles });
      }

      if (response.data.code === 200) {
        setIsOpen(false);
        refetch();
        success(
          response?.data?.message || modalData
            ? "Client Updated SUccessfully"
            : "Client Added Successfully"
        );
      }
    } catch (error) {
      if (error?.response && error?.response?.data?.message) {
        errorToast(error?.response?.data?.message, "error");
      }
    }
  };

  useEffect(() => {
    if (modalData) {
      setValue("name", modalData.name);
      setValue("email", modalData.email);
      setValue("mobile_no", modalData.mobile_no);
      setValue("username", modalData.username);
      setValue("password", modalData.password_view);
      setValue("designation", modalData.designation);
      setValue("address", modalData.address);
      setValue("member_number", modalData.member_number);
      setValue("insurance_provider", modalData.insurance_provider);
      setValue("notes", modalData.notes);
      setValue("dob", formatDate(modalData.dob));
      setImageFiles(
        modalData.attachments?.map((x) => {
          if (
            x?.media_type !== "png" ||
            x?.media_type !== "jpg" ||
            x?.media_type !== "jpeg"
          )
            return "/images/pdf.png";
          else return x?.media_url;
        })
      );
    } else {
      reset();
    }
  }, []);

  return (
    <div className="edit-profile-content">
      <Form
        onSubmit={handleSubmit(onSubmit)}
        className="form-edit-profile mt-2"
      >
        <ThemeInput
          name="name"
          errors={errors}
          control={control}
          type={"text"}
          className={""}
          placeholder={"Full Name"}
          rules={{
            required: {
              value: true,
              message: validationText.nameRequired,
            },
            maxLength: {
              value: validation.nameMax,
              message: validationText.nameMax,
            },
          }}
        />
        <ThemeInput
          name="email"
          errors={errors}
          control={control}
          type={"email"}
          className={"mt-3"}
          placeholder={"Email"}
          rules={{
            required: {
              value: true,
              message: validationText.emailRequired,
            },
            maxLength: {
              value: validation.emailMax,
              message: validationText.emailMax,
            },
          }}
        />
        <ThemeInput
          name="mobile_no"
          errors={errors}
          control={control}
          type={"number"}
          className={"mt-3"}
          placeholder={"Phone"}
          rules={{
            required: {
              value: true,
              message: validationText.phoneNumber,
            },
            maxLength: {
              value: validation.phoneNumber,
              message: validationText.phoneNumberMax,
            },
          }}
        />
        <ThemeInput
          name="address"
          errors={errors}
          control={control}
          type={"text"}
          className={"mt-3"}
          placeholder={"Address"}
          rules={{
            required: {
              value: true,
              message: validationText.nameRequired,
            },
            maxLength: {
              value: validation.nameMax,
              message: validationText.nameMax,
            },
          }}
        />
        <ThemeInput
          name="dob"
          errors={errors}
          control={control}
          type={"date"}
          className={"mt-3"}
          placeholder={"Date Of Birth"}
          rules={{
            required: {
              value: true,
              message: validationText.nameRequired,
            },
            maxLength: {
              value: validation.nameMax,
              message: validationText.nameMax,
            },
          }}
        />
        <ThemeInput
          name="member_number"
          errors={errors}
          control={control}
          type={"number"}
          className={"mt-3"}
          placeholder={"Member Number"}
          rules={{ required: "Member Number is required" }}
        />
        <ThemeInput
          name="insurance_provider"
          errors={errors}
          control={control}
          type={"text"}
          className={"mt-3"}
          placeholder={"Insurance Provider"}
          rules={{ required: "Insurance Provider is required" }}
        />
        <ThemeTextArea
          name="notes"
          errors={errors}
          control={control}
          type={"testarea"}
          className={""}
          placeholder={"Notes"}
          as={"textarea"}
          row={10}
          // rules={{
          //   required: {
          //     value: true,
          //     message: validationText.phoneNumber,
          //   },
          //   maxLength: {
          //     value: validation.phoneNumberMax,
          //     message: validationText.phoneNumberMax,
          //   },
          // }}
        />

        <SimpleBasic
          text={"Patient Documents"}
          className={"mt-4 mb-0 fw-semibold"}
        />
        <div className="d-flex gap-3 mt-2">
          <div className="p-4 border rounded-1 bg-gray">
            <input
              type="file"
              accept="image/png image/jpeg image/application"
              id="addimges"
              style={{ display: "none" }}
              onChange={handleAddfilesAndSelect}
            />

            <div
              onClick={() => document.getElementById("addimges").click()}
              className={"cursor"}
              disabled={attchadding}
            >
              {attchadding ? <ThemeSpinner /> : <PlusIcon />}
            </div>
          </div>
          <div
            className="overflow-x-auto overflow-y-hidden gap-2"
            style={{ height: "80px", width: "350px" }}
          >
            <SwipperComponent
              modules={[Navigation, Pagination, Scrollbar, A11y]}
              spaceBetween={0}
              className="main-slider"
              freeMode={true}
              watch
              slidesPerView={4}
              navigation
              pagination={{
                clickable: true,
                dynamicBullets: true,
              }}
            >
              {imageFiles.map((file, index) => (
                <img
                  key={index}
                  src={
                    // file === "/images/pdf_image.png"
                    //   ? file
                    //   : URL.createObjectURL(file)
                    file
                  }
                  height={80}
                  width={80}
                  className="bg-gray p-2 ms-2 object-fit-content"
                ></img>
              ))}
            </SwipperComponent>
          </div>
        </div>

        <div className="d-flex gap-3 mt-4">
          <div className="btn-submit w-50">
            <Button
              className="cancel-btn w-100 bg-grey"
              onClick={() => setIsOpen(false)}
            >
              Cancel
            </Button>
          </div>
          <div className="btn-submit w-50">
            <Button
              disabled={isLoading}
              type="submit"
              className="theme-btn w-100"
            >
              {isLoading || addLoading ? (
                <ThemeSpinner />
              ) : modalData ? (
                "Update Patient"
              ) : (
                "Add Patient"
              )}
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default AddPatient;